export default "<mea-menu-item *ngFor=\"let item of items\" [item]=\"item\" [activity]=\"activity\" (click)=\"clicked(item.eventName)\">\r\n</mea-menu-item>"